import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, AlertTriangle, Plus, Link2, Check } from "lucide-react";
import { api } from "../lib/api";
import { Button } from "./ui/button";

// Custody-history auto link + list of fuel plates not found in the fleet (add them in one click).
export const FuelFleetTools = ({ onChanged, refreshKey }) => {
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState("");
  const [added, setAdded] = useState(new Set());
  const load = useCallback(() => api.fuelUnknownPlates().then((r) => setItems(r.items)).catch(() => setItems([])), []);
  useEffect(() => { load(); }, [load, refreshKey]);
  const rematch = async () => {
    setBusy("rematch");
    try {
      const r = await api.fuelRematchCustody();
      if (r.linked) toast.success(`رُبط ${r.linked} سجل وقود (${r.plates} لوحة) بمستلم المركبة في تاريخ التعبئة`);
      else toast.info(r.checked ? `لم يُعثر على مستلم في سجل العهد لـ ${r.checked} سجل` : "كل سجلات الوقود مربوطة");
      onChanged?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الربط"); } finally { setBusy(""); }
  };
  const add = async (x) => {
    setBusy(x.plate);
    try { await api.createAsset({ type: "سيارة", identifier: x.plate, branch: "", notes: "أضيفت من ملف الوقود" }); setAdded((s) => new Set(s).add(x.plate)); toast.success(`أضيفت ${x.plate} للأسطول — سلّمها لموظف من صفحة المركبات`); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّرت الإضافة"); } finally { setBusy(""); }
  };
  return (
    <div className="mt-2 space-y-3">
      <Button variant="outline" onClick={rematch} disabled={!!busy} className="h-9 gap-1.5 border-emerald-200 text-emerald-700 hover:bg-emerald-50" data-testid="fuel-rematch-custody">
        {busy === "rematch" ? <Loader2 className="h-4 w-4 animate-spin" /> : <Link2 className="h-4 w-4" />} ربط تلقائي من العهد</Button>
      {items?.length > 0 && (
        <div className="rounded-xl border border-amber-200 bg-amber-50/60 p-3" data-testid="fuel-unknown-plates">
          <p className="mb-2 flex items-center gap-1.5 text-sm font-bold text-amber-900"><AlertTriangle className="h-4 w-4" /> لوحات في ملفات الوقود غير موجودة في الأسطول ({items.length})</p>
          <div className="max-h-48 space-y-1 overflow-y-auto">
            {items.map((x) => (
              <div key={x.plate} className="flex items-center justify-between gap-2 rounded-lg bg-white px-3 py-1.5 text-xs" data-testid={`fuel-unknown-${x.plate}`}>
                <span className="font-bold" dir="ltr">{x.plate}</span>
                <span className="text-slate-500">{x.records} تعبئة · {x.amount.toLocaleString("en-US")} ر.س · آخر شهر {x.last_month}</span>
                {added.has(x.plate) ? <span className="inline-flex items-center gap-1 text-emerald-700"><Check className="h-3.5 w-3.5" /> أضيفت</span>
                  : <button onClick={() => add(x)} disabled={!!busy} className="inline-flex items-center gap-1 rounded-full bg-amber-600 px-2.5 py-1 font-bold text-white hover:bg-amber-700" data-testid={`fuel-unknown-add-${x.plate}`}>
                    {busy === x.plate ? <Loader2 className="h-3 w-3 animate-spin" /> : <Plus className="h-3 w-3" />} إضافة للأسطول</button>}
              </div>))}
          </div>
        </div>)}
    </div>
  );
};
